import Queue from "nq";
import AuditLogsUseCase from "../logs/AuditLogsUseCase";

class SignInUseCase {
  async execute(user, options) {
    const result = await new Queue.User().signIn(user, options);
    if (result) {
      const object = { "": "" };
      try {
        new AuditLogsUseCase().execute(
          "IN",
          object,
          "Successful Login Attempt",
          "LOGGED"
        );
      } catch (e) {
        console.error(e.message || e);
      }
    }
    return result;
  }
}

export default SignInUseCase;
